import { useContext, useState } from "react";
import Select from "react-select";
import { AuthContext } from "../contexts/AuthContext";
import useLabourers from "../hooks/useLabourers";

import supportTicketStatuses from "../data/supportTicketStatuses.json";
import supportTicketPriorities from "../data/supportTicketPriorities.json";

const TicketForm = ({ onSubmit, ticket }) => {
  const { user: activeUser } = useContext(AuthContext);

  const defaultStatus = supportTicketStatuses.find(s => s.value === 'Open');
  const initialStatus = ticket?.status ? { value: ticket.status, label: ticket.status } : defaultStatus;

  const defaultPriority = supportTicketPriorities.find(p => p.value === 'TBD');
  const initialPriority = ticket?.priority ? { value: ticket.priority, label: ticket.priority } : defaultPriority;

  const { data } = useLabourers({ shouldFetch: activeUser?.role === 'admin', page: 1, perPage: 10000 });
  const labourers = data?.labourers;

  const ticketCreator = labourers ? labourers?.find(l => l.user._id === ticket?.createdBy._id) : null;
  const initialUser = labourers && ticketCreator && activeUser.role === 'admin' ? { value: ticketCreator.user._id, label: ticketCreator.user.fullName } : null;

  const [title, setTitle] = useState(ticket?.title || '');
  const [user, setUser] = useState(initialUser);
  const [status, setStatus] = useState(initialStatus);
  const [priority, setPriority] = useState(initialPriority);
  const [description, setDescription] = useState(ticket?.description || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      title,
      description
    }

    if (activeUser.role === 'admin') {
      payload.user = user.value;
      payload.status = status.value;
      payload.priority = priority.value;
    }

    onSubmit(payload);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full"
    >
      <div className="p-4 flex flex-col gap-4">
        <label className="flex flex-col gap-1 w-full">
          <span>Title</span>

          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </label>

        {activeUser.role === 'admin' && (
          <label className="flex flex-col gap-1 w-full">
            <span>User</span>

            <Select
              options={labourers?.map(u => ({ value: u.user._id, label: u.user.fullName }))}
              value={labourers ? user : null}
              onChange={(selected) => setUser(selected)}
            />
          </label>
        )}

        {activeUser.role === 'admin' && (
          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <label className='flex flex-col w-full gap-2'>
              <span className="text-left">Status:</span>

              <Select
                options={supportTicketStatuses}
                value={status}
                onChange={(selected) => setStatus(selected)}
              />
            </label>

            <label className='flex flex-col w-full gap-2'>
              <span className="text-left">Priority:</span>

              <Select
                options={supportTicketPriorities}
                value={priority}
                onChange={(selected) => setPriority(selected)}
              />
            </label>
          </div>
        )}

        <label className='flex flex-col gap-1'>
          <span>Description</span>

          <textarea
            className='border rounded-md p-2 min-h-[100px]'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>

        <button className="ase-button-primary h-[48px]">
          Submit
        </button>
      </div>
    </form>
  )
}

export default TicketForm;
